export const COMPONENT_CONSTRUCTED = 'COMPONENT_CONSTRUCTED';
export const SET_ALERT = 'SET_ALERT';
export const SHOW_LOADER = 'SHOW_LOADER';